<template>
  <div style="display: flex; flex-flow: column; overflow: hidden">
    <div class="homepage">
      <homePageIndex class="left"></homePageIndex>
      <div class="right">
        <div class="about">
          <h1>This is an about page</h1>
        </div>
        Mouse position is at: {{ x }}, {{ y }}
        <input v-focus />

        <nav>
          <router-link to="/about/">About</router-link> |
          <router-link to="/about/indexPage">index</router-link>
        </nav>
        <router-view />
      </div>
    </div>
    <div></div>
  </div>
</template>

<script setup>
import homePageIndex from "@/views/homePage/homePageIndex.vue";
import { ref, onMounted, onUnmounted } from "vue";

const x = ref(0);
const y = ref(0);

function update(event) {
  x.value = event.pageX;
  y.value = event.pageY;
}

onMounted(() => window.addEventListener("mousemove", update));
onUnmounted(() => window.removeEventListener("mousemove", update));

const vFocus = {
  mounted: (el) => el.focus(),
};
</script>
<style lang="less" scoped>
.homepage {
  flex: 1;
  display: flex;
  height: 0;
  overflow: hidden;
}
.left {
  height: 100%;
  overflow-y: auto;
}

.right {
  flex: 1;
}
</style>
